import { InfosecLevel } from "@istari/istari-client";

import { useGetPlatformInfosecSettings } from "../api/useInfosecLevels";
import { usePlatformInfosecActive } from "../hooks";
import { ClassificationBanner } from "./classification-banner";

const BANNER_HEIGHT = 32;

type InfosecBannerData = {
  enabled: boolean;
  maxLevel: InfosecLevel | null | undefined;
  bannerOffset: number;
};

export function InfosecBanner() {
  const { enabled, maxLevel } = useInfosecBannerData();

  if (!enabled || !maxLevel) {
    return null;
  }

  return (
    <div
      className="bg-background fixed top-0 right-0 left-0 z-50 p-1"
      style={{
        height: `${BANNER_HEIGHT}px`,
      }}
      role="banner"
    >
      <ClassificationBanner level={maxLevel} label="Workspace Classification Level" />
    </div>
  );
}

export function useInfosecBannerData(): InfosecBannerData {
  const enabled = usePlatformInfosecActive();
  const platformSettingsQuery = useGetPlatformInfosecSettings();
  const maxLevel = platformSettingsQuery.data?.maxLevel;
  const bannerOffset = enabled && maxLevel ? BANNER_HEIGHT : 0;

  return { enabled, maxLevel, bannerOffset };
}

export function getInfosecBannerHeight(enabled: boolean, hasMaxLevel: boolean): number {
  return enabled && hasMaxLevel ? BANNER_HEIGHT : 0;
}
